import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/index.js';
import { Button } from '../components/button.js';

export function Login() {
  const { isAuthenticated, isLoading, login } = useAuth();
  const from = (useLocation().state as { from?: string } | null)?.from;

  if (isLoading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4" style={{ borderColor: 'var(--color-border-2)', borderTopColor: 'var(--color-brand)' }} />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to={from && from.startsWith('/') && !from.startsWith('//') ? from : '/'} replace />;
  }

  return (
    <div className="flex min-h-screen items-center justify-center" style={{ backgroundColor: 'var(--color-bg)' }}>
      <div className="animate-scale-in card w-full max-w-sm rounded-lg p-8" style={{ border: '1px solid var(--color-border-2)' }}>
        <div className="text-center">
          <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 42, color: 'var(--color-text)', letterSpacing: '0.04em', lineHeight: 1 }}>AI</h1>
          <p style={{ fontFamily: 'var(--font-display)', fontSize: 13, color: 'var(--color-brand)', letterSpacing: '0.25em', lineHeight: 1, marginTop: 2 }}>DEV</p>
        </div>
        <p className="mt-4 text-center text-xs" style={{ color: 'var(--color-text-3)', fontFamily: 'var(--font-mono)', letterSpacing: '0.1em' }}>
          OPERATIONAL COCKPIT
        </p>
        <Button onClick={() => void login(from)} className="mt-8 w-full">
          Sign in with Cognito
        </Button>
      </div>
    </div>
  );
}
